// ABOUTME: Hook that resolves whether the ThreeViewLayout left drawer hosting a PimSideBar shows:
// ABOUTME: hidden while the cart is docked open beside the page, the layout's own state otherwise.

import { CartDockContext } from '@src/_new/modules/cpq/components/Cart/CartDockContext';
import { useContext } from 'react';

/**
 * The `leftOpen` of a page's ThreeViewLayout: `false` while the docked cart takes the room on the
 * right, `undefined` otherwise, so the layout keeps showing the sidebar as it always did.
 */
export function usePimSidebarOpen(): boolean | undefined {
    const cartDockedOpen = useContext(CartDockContext);

    return cartDockedOpen ? false : undefined;
}
